import z from "zod";

const hubspotErrorTypeValues = [
  "MISSING_CREDENTIALS",
  "API_NOT_ENABLED",
  "RETRY_LIMIT_REACHED",
  "INVALID_OWNER_RESPONSE",
  "API_REQUEST_FAILED",
] as const;

const hubspotErrorTypeSchema = z.enum(hubspotErrorTypeValues);
const HubspotErrorType = hubspotErrorTypeSchema.enum;
type HubspotErrorType = z.infer<typeof hubspotErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type HubspotErrors =
  | {
      errorType: typeof HubspotErrorType.MISSING_CREDENTIALS;
      data: undefined;
    }
  | {
      errorType: typeof HubspotErrorType.API_NOT_ENABLED;
      data: undefined;
    }
  | {
      errorType: typeof HubspotErrorType.RETRY_LIMIT_REACHED;
      data: {
        maxRetries: number;
      };
    }
  | {
      errorType: typeof HubspotErrorType.INVALID_OWNER_RESPONSE;
      data: undefined;
    }
  | {
      errorType: typeof HubspotErrorType.API_REQUEST_FAILED;
      data: {
        endpoint: string;
        bidId?: number;
        status?: number;
        statusText?: string;
        retryAfterSeconds?: number;
      };
    };

export const hubspotErrorDetails: Record<HubspotErrorType, ErrorDetails> = {
  [HubspotErrorType.MISSING_CREDENTIALS]: {
    sentryDescription: "Missing Hubspot API credentials",
  },
  [HubspotErrorType.API_NOT_ENABLED]: {
    sentryDescription: "Hubspot API access is not enabled",
  },
  [HubspotErrorType.RETRY_LIMIT_REACHED]: {
    sentryDescription: "Exceeded Hubspot API retry attempts",
  },
  [HubspotErrorType.INVALID_OWNER_RESPONSE]: {
    sentryDescription: "Hubspot owner response failed validation",
  },
  [HubspotErrorType.API_REQUEST_FAILED]: {
    sentryDescription: "Hubspot API request failed",
  },
};
